import {
  API_CLEAR_RESPONSE_MESSAGE,
  API_DISPLAY_RESPONSE_MESSAGE,
} from "redux/constants/ApiMessageResponse";

const initState = {
  showMessage: false,
  message: "",
  messageType: null,
};

const apiMessageResponse = (state = initState, action) => {
  switch (action.type) {
    case API_CLEAR_RESPONSE_MESSAGE:
      return {
        showMessage: false,
        message: "",
        messageType: null,
      };
    case API_DISPLAY_RESPONSE_MESSAGE:
      return {
        showMessage: action.data.showMessage,
        message: action.data.message,
        messageType: action.data.messageType,
      };

    default:
      return state;
  }
};

export default apiMessageResponse;
